import React from 'react';

const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
  setPrimaryColorLight: () => {},
  setPrimaryColorDark: () => {},
  mode: 'dark',
});

export default ColorModeContext;
